import { createAppSelector } from 'app-components/utils/core/reselect';
import type RootState from 'app-components/utils/redux-store/rootState';

import { getDangerouslyUseFeatureFlags } from './featureFlagsReducer';
import * as featureFlagsTypes from './featureFlagsTypes';

type State = Pick<RootState, typeof featureFlagsTypes.FEATURE_FLAGS_REDUCER_KEY>;

const getResourceStore = (state: State) => state[featureFlagsTypes.FEATURE_FLAGS_REDUCER_KEY];
export const getFeatureFlags = (state: State) => getResourceStore(state).featureFlags;
export const getFeatureFlag = <K extends featureFlagsTypes.FeatureFlagsKeys>(
  state: State,
  key: K,
): featureFlagsTypes.FeatureFlagsProps[K] | undefined => getResourceStore(state).featureFlags.get(key);
export const getLoadPending = (state: State) => getResourceStore(state).loadPending;
export const getIsLoading = (state: State) => getResourceStore(state).isLoading;
export const getError = (state: State) => getResourceStore(state).error;

export const getFeatureFlagEnsured = (state: State, key: featureFlagsTypes.FeatureFlagsKeys) =>
  !getLoadPending(state) || !getIsLoading(state) || getError(state) ? getFeatureFlag(state, key) : null;

export const isAiEnabled = createAppSelector(
  [getFeatureFlags],
  (featureFlags) =>
    !!featureFlags.get('aiChatV2') || !!featureFlags.get('aiSummarize') || !!featureFlags.get('investmentsWhy'),
);

export const dangerouslyUseFeatureFlags = () => getDangerouslyUseFeatureFlags();

export const getEnabledFeatureFlags = (state: State) =>
  getFeatureFlags(state)
    .filter((value) => Boolean(value))
    .keySeq()
    .toArray();
